var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserMyServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4535 27.8337C24.4535 22.6737 19.3202 18.5003 13.0002 18.5003C6.68021 18.5003 1.54688 22.6737 1.54688 27.8337M13.0002 14.5003C14.7683 14.5003 16.464 13.7979 17.7143 12.5477C18.9645 11.2975 19.6669 9.60177 19.6669 7.83366C19.6669 6.06555 18.9645 4.36986 17.7143 3.11961C16.464 1.86937 14.7683 1.16699 13.0002 1.16699C11.2321 1.16699 9.53641 1.86937 8.28616 3.11961C7.03592 4.36986 6.33354 6.06555 6.33354 7.83366C6.33354 9.60177 7.03592 11.2975 8.28616 12.5477C9.53641 13.7979 11.2321 14.5003 13.0002 14.5003Z",
    stroke: "#303030",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMyServices);
export default __webpack_public_path__ + "static/media/user-my-services.d98a57cd5803b7fbec0154173b766bda.svg";
export { ForwardRef as ReactComponent };